/**
 * GA4 dataLayer katmani — Stiletto (Fluorescent) temasi icin.
 *
 * Bu dosya temanin kendi custom event sistemine baglanir; fetch monkey-patch
 * yapmaz. Calismasi icin snippets/theme-globals.liquid icinde
 * `useCustomEvents` true olmalidir (window.flu.states.useCustomEvents).
 *
 * Uretilen event'ler:
 *   view_item_list, select_item, add_to_cart, remove_from_cart,
 *   view_cart, begin_checkout, view_promotion, select_promotion
 *
 * view_item — sections/main-product--default.liquid icinden push edilir.
 * Checkout event'leri (add_shipping_info / add_payment_info / purchase)
 * Shopify Custom Pixel tarafindan uretilir.
 */

window.dataLayer = window.dataLayer || [];

window.FahharGTM = (function () {
  'use strict';

  var STORAGE_KEY = 'fahhar_gtm_item_list';
  var LIST_TTL_MS = 1000 * 60 * 60 * 24 * 7; // 7 gun
  var MAX_LIST_ENTRIES = 300;

  /* ─── Yardimcilar ───────────────────────────────────────────────────── */

  /**
   * Shopify fiyatlari kurus (cents) cinsindendir. GA4 ondalik bekler.
   */
  function money(cents) {
    var value = Number(cents);
    if (!isFinite(value)) return undefined;
    return Math.round(value) / 100;
  }

  function currencyCode() {
    return (
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
      'TRY'
    );
  }

  /**
   * "SAL > Duz Sal > KRINKIL" -> item_category, item_category2, item_category3
   * En fazla 4 seviye.
   */
  function parseCategories(productType) {
    if (!productType) return {};
    var parts = String(productType)
      .split('>')
      .map(function (s) { return s.trim(); })
      .filter(Boolean);
    var keys = ['item_category', 'item_category2', 'item_category3', 'item_category4'];
    var result = {};
    parts.slice(0, 4).forEach(function (part, i) { result[keys[i]] = part; });
    return result;
  }

  /**
   * Merchant Center offer ID'si.
   *
   * Shopify'in Google & YouTube app'i feed'i su bicimde uretiyor:
   *   shopify_ZZ_9126631473380_49343464571108
   *   shopify_<ulke>_<productId>_<variantId>
   *
   * GA4 item_id bununla BIREBIR ayni olmali; yoksa dinamik remarketing ve
   * Shopping urun raporlari eslesmez. Feed'in ulke kodu degisirse burayi
   * ve 3 Liquid sablonunu (product-item, product-card-mini,
   * predictive-search) birlikte guncelle.
   */
  var MC_PREFIX = 'shopify_ZZ_';

  function merchantItemId(productId, variantId) {
    if (!productId || !variantId) return String(variantId || productId || '');
    return MC_PREFIX + productId + '_' + variantId;
  }

  /**
   * Shopify GID veya duz id -> sayisal id string'i.
   */
  function numericId(value) {
    if (value === null || value === undefined || value === '') return '';
    var parts = String(value).split('/');
    return parts[parts.length - 1];
  }

  function readStore() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : {};
    } catch (e) {
      return {};
    }
  }

  function writeStore(store) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
    } catch (e) { /* kota dolu veya erisim yok */ }
  }

  /**
   * Urunun hangi listeden geldigini sakla. Tum huni boyunca
   * item_list_id / item_list_name tasinmasini bu saglar.
   */
  // batchListContext() icindeyken yazimlar bellekte toplanir, sonunda tek
  // seferde depoya yazilir.
  var batchStore = null;
  var batchDirty = false;

  function pruneStore(store) {
    var keys = Object.keys(store);
    if (keys.length > MAX_LIST_ENTRIES) {
      keys
        .sort(function (a, b) { return (store[a].t || 0) - (store[b].t || 0); })
        .slice(0, keys.length - MAX_LIST_ENTRIES)
        .forEach(function (k) { delete store[k]; });
    }
  }

  function setItemListContext(productId, listId, listName) {
    if (!productId || !listId) return;
    var store = batchStore || readStore();
    store[String(productId)] = {
      item_list_id: String(listId),
      item_list_name: listName ? String(listName) : '',
      t: Date.now()
    };
    if (batchStore) { batchDirty = true; return; }

    pruneStore(store);
    writeStore(store);
  }

  /**
   * Bir listenin tum kartlari icin baglami tek okuma + tek yazma ile saklar.
   * (Kart basina ayri okuma/yazma, 40 kartlik listede telefonda ana is
   * parcacigini gozle gorulur sure tutuyordu.)
   */
  function batchListContext(work) {
    if (batchStore) { work(); return; }
    batchStore = readStore();
    batchDirty = false;
    try {
      work();
    } finally {
      var store = batchStore;
      batchStore = null;
      if (batchDirty) {
        pruneStore(store);
        writeStore(store);
      }
    }
  }

  function getItemListContext(productId) {
    if (!productId) return null;
    var entry = readStore()[String(productId)];
    if (!entry) return null;
    if (entry.t && Date.now() - entry.t > LIST_TTL_MS) return null;
    return { item_list_id: entry.item_list_id, item_list_name: entry.item_list_name };
  }

  /**
   * GA4 spec: her ecommerce event'inden once ecommerce objesi sifirlanir,
   * yoksa onceki event'in item'lari yeni event'e sizar.
   */
  function pushEvent(eventData) {
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(eventData);
  }

  /**
   * undefined / null / '' alanlari temizler — GA4'e bos parametre gitmesin.
   */
  function clean(object) {
    var result = {};
    Object.keys(object).forEach(function (key) {
      var value = object[key];
      if (value !== undefined && value !== null && value !== '') result[key] = value;
    });
    return result;
  }

  return {
    money: money,
    currencyCode: currencyCode,
    parseCategories: parseCategories,
    numericId: numericId,
    merchantItemId: merchantItemId,
    setItemListContext: setItemListContext,
    batchListContext: batchListContext,
    getItemListContext: getItemListContext,
    pushEvent: pushEvent,
    clean: clean
  };
})();

/* ═══════════════════════════════════════════════════════════════════════
   view_item_list + select_item
   [data-gtm-list-id] tasiyan her kap izlenir. Icindeki urun kartlari
   <script type="application/json" data-gtm-product> ile veri sunar.
   ═══════════════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  var G = window.FahharGTM;
  var initialized = new WeakSet();

  // Urun karti sayilan tum varyantlar. Yeni bir kart tipi eklenirse
  // yalnizca buraya eklemek yeterli.
  var CARD_SELECTOR = [
    '.product-item',
    '.product-card-mini',
    '.quick-search__result--product'
  ].join(', ');

  function cardData(card) {
    var holder = card.querySelector('[data-gtm-product]');
    if (!holder) return null;
    try {
      return JSON.parse(holder.textContent);
    } catch (e) {
      return null;
    }
  }

  function buildItem(card, listId, listName, index) {
    var data = cardData(card);
    if (!data || !data.item_id) return null;

    var item = G.clean({
      item_id: String(data.item_id),
      item_variant_id: data.item_variant_id,
      item_name: data.item_name,
      item_brand: data.item_brand,
      item_variant: data.item_variant,
      item_sku: data.item_sku,
      price: data.price,
      quantity: 1,
      index: index,
      item_list_id: String(listId),
      item_list_name: listName
    });

    Object.assign(item, G.parseCategories(data.item_type));

    // Liste baglami URUN id'siyle saklanir: kullanici PDP'de baska bir
    // varyant secse de baglam korunur.
    G.setItemListContext(data.item_product_id || data.item_id, listId, listName);

    return item;
  }

  var lastSignature = new WeakMap();

  // view_item_list ile daha once gonderilmis kartlar. Sonsuz kaydirmada
  // kaba yeni sayfa eklenince yalnizca yeni kartlar gonderilir; aksi halde
  // her eklemede tum liste (40, 80, 120...) yeniden giderdi.
  var sentCards = new WeakSet();

  function cardItemId(card) {
    var data = cardData(card);
    return data && data.item_id ? String(data.item_id) : '';
  }

  function fireViewItemList(container) {
    var listId = container.getAttribute('data-gtm-list-id');
    var listName = container.getAttribute('data-gtm-list-name') || '';
    if (!listId) return;

    var cards = container.querySelectorAll(CARD_SELECTOR);
    if (!cards.length) return;

    // Ayni liste tekrar gonderilmesin. Anlik aramada kap sabittir ama
    // icerik her sorguda degisir; imza degisince yeni liste gonderilir.
    var signature = Array.prototype.map.call(cards, cardItemId).filter(Boolean).join(',');
    if (!signature || lastSignature.get(container) === signature) return;
    lastSignature.set(container, signature);

    var startIndex = parseInt(container.getAttribute('data-gtm-start-index'), 10);
    if (!isFinite(startIndex)) startIndex = 0;

    // Sira numarasi listedeki gercek konumdur; yalnizca yeni kartlar eklenir.
    var items = [];
    G.batchListContext(function () {
      Array.prototype.forEach.call(cards, function (card, i) {
        if (sentCards.has(card)) return;
        var item = buildItem(card, listId, listName, startIndex + i + 1);
        if (!item) return;
        sentCards.add(card);
        items.push(item);
      });
    });
    if (!items.length) return;

    G.pushEvent({
      event: 'view_item_list',
      ecommerce: {
        item_list_id: String(listId),
        item_list_name: listName,
        items: items
      }
    });
  }

  function observe(container) {
    if (initialized.has(container)) return;
    initialized.add(container);

    var pending = null;

    // Lazy görsel, swiper sinif degisimi gibi mutasyonlar sik tetiklenir;
    // her birinde tum karti yeniden okumamak icin topluyoruz.
    function scheduleAttempt() {
      if (pending) return;
      pending = setTimeout(function () {
        pending = null;
        fireViewItemList(container);
      }, 250);
    }

    function onVisible() {
      fireViewItemList(container);

      // Icerik sonradan gelebilir veya degisebilir: anlik arama,
      // son gezilen urunler, sonsuz kaydirma, filtre yenileme.
      new MutationObserver(scheduleAttempt).observe(container, {
        childList: true,
        subtree: true
      });
    }

    if (!('IntersectionObserver' in window)) {
      onVisible();
      return;
    }

    // Kural: kabin en az %15'i gorunur olunca liste "goruldu" sayilir.
    // Ekrandan cok uzun kaplarda (or. 40 urunluk koleksiyon izgarasi) %15 ayni
    // anda ekrana sigmaz ve olay hic gitmezdi; boyle kaplar ekrana girdigi an
    // sayilir. Kisa kaplarin (karusel vb.) davranisi degismez.
    var MIN_RATIO = 0.15;
    var fired = false;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (fired || !entry.isIntersecting) return;
        var viewport = entry.rootBounds ? entry.rootBounds.height : window.innerHeight;
        var reachable = entry.boundingClientRect.height * MIN_RATIO <= viewport;
        if (reachable && entry.intersectionRatio < MIN_RATIO) return;
        fired = true;
        observer.disconnect();
        onVisible();
      });
    }, { threshold: [0, MIN_RATIO] });

    observer.observe(container);
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var containers = scope.querySelectorAll('[data-gtm-list-id]');
    Array.prototype.forEach.call(containers, observe);
  }

  function init() {
    scan(document);

    // Sonsuz kaydirma, filtre yenileme ve quick-view sonrasi eklenen
    // listeleri de yakala.
    var mutationObserver = new MutationObserver(function (mutations) {
      var shouldScan = false;
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes, function (node) {
          if (node.nodeType !== 1) return;
          if (node.hasAttribute && node.hasAttribute('data-gtm-list-id')) shouldScan = true;
          else if (node.querySelector && node.querySelector('[data-gtm-list-id]')) shouldScan = true;
        });
      });
      if (shouldScan) scan(document);
    });

    mutationObserver.observe(document.body, { childList: true, subtree: true });
  }

  /* ─── select_item: liste icindeki urun linkine tiklama ──────────────── */

  function onSelect(event) {
    var link = event.target.closest('a[href*="/products/"]');
    if (!link) return;

    var card = link.closest(CARD_SELECTOR);
    if (!card) return;

    var container = card.closest('[data-gtm-list-id]');
    if (!container) return;

    var listId = container.getAttribute('data-gtm-list-id');
    var listName = container.getAttribute('data-gtm-list-name') || '';

    var cards = container.querySelectorAll(CARD_SELECTOR);
    var index = Array.prototype.indexOf.call(cards, card);
    var startIndex = parseInt(container.getAttribute('data-gtm-start-index'), 10);
    if (!isFinite(startIndex)) startIndex = 0;

    var item = buildItem(card, listId, listName, startIndex + index + 1);
    if (!item) return;

    G.pushEvent({
      event: 'select_item',
      ecommerce: {
        item_list_id: String(listId),
        item_list_name: listName,
        items: [item]
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('click', onSelect, true);
})();

/* ═══════════════════════════════════════════════════════════════════════
   add_to_cart — temanin native `cart:item-added` event'i
   ═══════════════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  var G = window.FahharGTM;

  /**
   * Stiletto, /cart/add.js yanitindaki line item objesini gonderir:
   * { id, product_id, variant_id, product_title, variant_title, vendor,
   *   product_type, price, quantity, sku, ... }
   */
  function lineItemToGA4(line) {
    if (!line) return null;

    var productId = G.numericId(line.product_id);
    var variantId = G.numericId(line.variant_id || line.id);
    var context = G.getItemListContext(productId) || {};

    var item = G.clean({
      item_id: G.merchantItemId(productId, variantId),
      item_variant_id: variantId,
      item_name: line.product_title || line.title,
      item_brand: line.vendor,
      item_variant: line.variant_title,
      item_sku: line.sku,
      price: G.money(line.price),
      quantity: Number(line.quantity) || 1,
      item_list_id: context.item_list_id,
      item_list_name: context.item_list_name
    });

    Object.assign(item, G.parseCategories(line.product_type));

    return item;
  }

  document.addEventListener('cart:item-added', function (event) {
    var line = event.detail && event.detail.product;
    var item = lineItemToGA4(line);
    if (!item) return;

    G.pushEvent({
      event: 'add_to_cart',
      ecommerce: {
        currency: G.currencyCode(),
        value: (item.price || 0) * (item.quantity || 1),
        items: [item]
      }
    });
  });

  window.FahharGTM.lineItemToGA4 = lineItemToGA4;
})();

/* ═══════════════════════════════════════════════════════════════════════
   remove_from_cart — `cart:updated` uzerinden sepet farki alinarak
   ═══════════════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  var G = window.FahharGTM;
  var snapshot = null;

  /**
   * Sepet satirlarini VARYANT ID'siyle esler.
   *
   * line.key kullanmiyoruz: /cart.js yanitindaki key ile temanin
   * cart:updated olayindaki key bicimi ayni olmayabiliyor. Eslesmeyince
   * fark alma "satir kayboldu" sanip yanlis remove_from_cart uretiyordu.
   * Varyant id her iki tarafta da ayni.
   */
  function toMap(cart) {
    var map = {};

    ((cart && cart.items) || []).forEach(function (line) {
      var key = String(line.variant_id || line.id || '');
      if (!key) return;

      if (map[key]) {
        // Ayni varyant birden fazla satirda olabilir (ozel secenekler).
        map[key] = Object.assign({}, map[key], {
          quantity: Number(map[key].quantity || 0) + Number(line.quantity || 0)
        });
      } else {
        map[key] = line;
      }
    });

    return map;
  }

  function cartUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/$/, '') + '/cart.js';
  }

  function loadSnapshot() {
    return fetch(cartUrl(), { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) { snapshot = toMap(cart); })
      .catch(function () { snapshot = {}; });
  }

  function diffAndFire(cart) {
    var next = toMap(cart);

    if (snapshot === null) {
      snapshot = next;
      return;
    }

    var removed = [];

    Object.keys(snapshot).forEach(function (key) {
      var before = snapshot[key];
      var after = next[key];
      var lostQty = after
        ? Number(before.quantity) - Number(after.quantity)
        : Number(before.quantity);

      if (lostQty > 0) {
        var item = G.lineItemToGA4(before);
        if (item) {
          item.quantity = lostQty;
          removed.push(item);
        }
      }
    });

    snapshot = next;

    if (!removed.length) return;

    var value = removed.reduce(function (sum, item) {
      return sum + (item.price || 0) * (item.quantity || 1);
    }, 0);

    G.pushEvent({
      event: 'remove_from_cart',
      ecommerce: {
        currency: G.currencyCode(),
        value: Math.round(value * 100) / 100,
        items: removed
      }
    });
  }

  document.addEventListener('cart:updated', function (event) {
    var cart = event.detail && event.detail.cart;
    if (!cart) return;
    diffAndFire(cart);
  });

  loadSnapshot();
})();

/* ═══════════════════════════════════════════════════════════════════════
   view_cart — native `quick-cart:open`, artik sepet sayfasi
   ═══════════════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  var G = window.FahharGTM;
  var lastFiredAt = 0;

  function cartItems(cart) {
    return ((cart && cart.items) || [])
      .map(function (line) { return G.lineItemToGA4(line); })
      .filter(Boolean);
  }

  function fireViewCart(cart) {
    if (!cart) return;

    // Quick cart birden fazla kez acilabilir; 2 sn icinde tekrarlama.
    var now = Date.now();
    if (now - lastFiredAt < 2000) return;
    lastFiredAt = now;

    var items = cartItems(cart);
    if (!items.length) return;

    G.pushEvent({
      event: 'view_cart',
      ecommerce: {
        currency: G.currencyCode(),
        value: G.money(cart.total_price),
        items: items
      }
    });
  }

  document.addEventListener('quick-cart:open', function (event) {
    var cart = event.detail && event.detail.cart;
    if (cart) {
      fireViewCart(cart);
      return;
    }

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root.replace(/\/$/, '') + '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(fireViewCart)
      .catch(function () {});
  });

  // /cart sayfasi
  if (/\/cart(\/|$|\?)/.test(window.location.pathname + window.location.search)) {
    document.addEventListener('DOMContentLoaded', function () {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root.replace(/\/$/, '') + '/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (response) { return response.json(); })
        .then(fireViewCart)
        .catch(function () {});
    });
  }

  window.FahharGTM.cartItems = cartItems;
})();

/* ═══════════════════════════════════════════════════════════════════════
   begin_checkout — quick-cart ve /cart sayfasindaki checkout butonu
   ═══════════════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  var G = window.FahharGTM;
  var lastFiredAt = 0;

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[name="checkout"], [data-gtm-begin-checkout]');
    if (!button) return;

    var now = Date.now();
    if (now - lastFiredAt < 3000) return;
    lastFiredAt = now;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    // Checkout'a yonlendirme baslamadan push'un dataLayer'a girmesi icin
    // senkron beklemiyoruz; GTM zaten kuyruktan okur.
    fetch(root.replace(/\/$/, '') + '/cart.js', {
      headers: { Accept: 'application/json' },
      keepalive: true
    })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var items = G.cartItems(cart);
        if (!items.length) return;

        G.pushEvent({
          event: 'begin_checkout',
          ecommerce: {
            currency: G.currencyCode(),
            value: G.money(cart.total_price),
            items: items
          }
        });
      })
      .catch(function () {});
  }, true);
})();

/* ═══════════════════════════════════════════════════════════════════════
   view_promotion / select_promotion
   [data-gtm-promo-id] tasiyan banner, slide ve kampanya alanlari
   ═══════════════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  var G = window.FahharGTM;
  var seen = new WeakSet();

  function promoPayload(element) {
    return G.clean({
      promotion_id: element.getAttribute('data-gtm-promo-id'),
      promotion_name: element.getAttribute('data-gtm-promo-name'),
      creative_slot: element.getAttribute('data-gtm-creative-slot'),
      creative_name: element.getAttribute('data-gtm-creative-name')
    });
  }

  function fireViewPromotion(element) {
    if (seen.has(element)) return;
    seen.add(element);

    var payload = promoPayload(element);
    if (!payload.promotion_id) return;

    G.pushEvent({
      event: 'view_promotion',
      ecommerce: payload
    });
  }

  function observe(element) {
    if (!('IntersectionObserver' in window)) {
      fireViewPromotion(element);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        // Slider'da gizli slide'lar da DOM'da durur; gorunurlugu dogrula.
        if (entry.target.offsetParent === null) return;
        observer.unobserve(entry.target);
        fireViewPromotion(entry.target);
      });
    }, { threshold: 0.5 });

    observer.observe(element);
  }

  function scan() {
    var elements = document.querySelectorAll('[data-gtm-promo-id]');
    Array.prototype.forEach.call(elements, function (element) {
      if (seen.has(element)) return;
      observe(element);
    });
  }

  function init() {
    scan();

    // Swiper slide degisimlerinde yeni slide gorunur hale gelir.
    var mutationObserver = new MutationObserver(function () { scan(); });
    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'aria-hidden']
    });
  }

  document.addEventListener('click', function (event) {
    var element = event.target.closest('[data-gtm-promo-id]');
    if (!element) return;

    var payload = promoPayload(element);
    if (!payload.promotion_id) return;

    G.pushEvent({
      event: 'select_promotion',
      ecommerce: payload
    });
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
